import React from 'react';
import { useTranslation } from 'react-i18next';

import NavigationBar from '../components/NavigationBar';
import MediaList from '../components/MediaList';
import Footer from '../components/Footer/Footer';
import Menus from '../components/Menus';
import Suppliers from '../components/Suppliers';

function Supplier() {
    const { t } = useTranslation();

    return (
        <div>
            <NavigationBar />
            <h1>{t('SUPPLIERS')}</h1>
            <Suppliers isSubtitle={false} />
            <MediaList mediaKey='SUPPLIER_BOTTOM' maxItems={1} isShortLine={true} />
            <Menus />
            <Footer />
        </div>
    );
}

export default Supplier;
